<mat-card class="sticker-detail">
  <div class="top-buttons">
    <button mat-raised-button (click)="deleteThisSticker()">
      <mat-icon>delete_forever</mat-icon>
    </button>

    <button mat-raised-button (click)="closeThisCard()">
      <mat-icon>keyboard_arrow_down</mat-icon>
    </button>
  </div>

  <mat-card-header>
  </mat-card-header>

  <mat-card-content>
    <textarea [(ngModel)]="sticker.comment" (ngModelChange)="stickerCommentChanged($event)"></textarea>

  </mat-card-content>
</mat-card>


